'use es6';

import { List } from 'immutable';
import { __ANY_LINK } from 'customer-data-filters/converters/listSegClassic/ListSegConstants';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import ReferenceResolverSearchType from 'reference-resolvers/schema/ReferenceResolverSearchType';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import memoize from 'transmute/memoize';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
const _parseListSegAssetId = memoize(operator => {
  const assetName = getIn(['field', 'metadata', 'assetName'], operator) || operator.field.name;
  const assetType = getIn(['field', 'metadata', 'assetType'], operator) || operator.field.type;
  return `${assetName}`.replace(`${assetType}-`, '');
});
class FilterOperatorEmailLinkInput extends Component {
  constructor() {
    super();
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        fieldName,
        onChange,
        value
      } = this.props;
      onChange(SyntheticEvent(value.set(fieldName, nextValue)));
    };
    this.handleOptionsChange = options => {
      if (isResolved(options)) {
        this.setState({
          loading: false,
          results: options.get('results').toList()
        });
      }
    };
    this.state = {
      loading: true,
      results: List()
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      fieldName,
      onChange,
      resolver,
      value
    } = this.props;
    const field = value.get(fieldName);
    if (!field || field === __ANY_LINK) {
      onChange(SyntheticEvent(value.set(fieldName, __ANY_LINK)));
    }
    if (resolver && resolver.search) {
      this.referenceAtom = resolver.search({
        count: 0,
        // Not used
        offset: 0,
        // Not used
        hasMore: false,
        // Not used
        query: _parseListSegAssetId(value)
      });
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  focus() {
    this.input.focus();
  }
  render() {
    const {
      className,
      fieldName,
      value
    } = this.props;
    const {
      loading,
      results
    } = this.state;
    const anyLinkOption = {
      text: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.anyLink'),
      value: __ANY_LINK
    };
    const error = loading ? false : undefined;
    return /*#__PURE__*/_jsx(UISelect, {
      className: className,
      defaultValue: __ANY_LINK,
      error: error,
      onChange: this.handleChange,
      options: [anyLinkOption, ...ReferenceRecord.toOptionsArray(results)],
      ref: component => this.input = component,
      value: value.get(fieldName)
    });
  }
}
FilterOperatorEmailLinkInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorEmailLinkInput.propTypes = {
  className: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverSearchType.isRequired,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorEmailLinkInput;